export default "__VITE_ASSET__CrHgIWa9__"